import { API_BASE } from "../../../config/api";
import React, { useEffect, useState } from "react";
import { Table, Spin, Grid } from "antd";
import axios from "axios";
import familyChildrenColumns from "../columns/familyChildrenColumns";
import FamilyChildModal from "../modals/FamilyChildModal";
import FolioModal from "../modals/FolioModal";
import SchemeModal from "../modals/SchemeModal";
import TransactionModal from "../modals/TransactionModal";
import FamilyFolioTable from "./FamilyFolioTable";   // ✅ wrapper

const { useBreakpoint } = Grid;

const getArn = () => localStorage.getItem("arn_number");

export default function FamilyChildrenTable({ masterPan }) {
  const [children, setChildren] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ modal states
  const [childModalOpen, setChildModalOpen] = useState(false);
  const [folioModalOpen, setFolioModalOpen] = useState(false);
  const [schemeModalOpen, setSchemeModalOpen] = useState(false);
  const [txnModalOpen, setTxnModalOpen] = useState(false);

  // ✅ selected records
  const [selectedChild, setSelectedChild] = useState(null);
  const [selectedFolio, setSelectedFolio] = useState(null);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [selectedTxn, setSelectedTxn] = useState(null);

  const screens = useBreakpoint();
  const isMobile = !screens.md; // ✅ below md = mobile

  useEffect(() => {
    if (!masterPan) return;
    setLoading(true);
    axios
      .get(
        `${API_BASE}/get_family_children.php?arn_no=${getArn()}&master_pan=${masterPan}`
      )
      .then((res) => setChildren(res.data.children || []))
      .catch(() => setChildren([]))
      .finally(() => setLoading(false));
  }, [masterPan]);

  if (loading) return <Spin />;

  // ✅ Mobile-specific columns
  const mobileColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <a
          onClick={() => {
            setSelectedChild(record);
            setChildModalOpen(true);
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "PAN",
      dataIndex: "pan",
      key: "pan",
      render: (text, record) => (
        <a
          onClick={() => {
            setSelectedChild(record);
            setChildModalOpen(true);
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "Current Value",
      dataIndex: ["totals", "current_value"],
      key: "current_value",
      render: (val) => `₹${Number(val || 0).toLocaleString()}`,
    },
  ];

  return (
    <>
      <Table
        className="family-table"
        rowKey="pan"
        columns={
          isMobile
            ? mobileColumns
            : familyChildrenColumns((record) => {
                setSelectedChild(record);
                setChildModalOpen(true);
              })
        }
        dataSource={children}
        bordered
        pagination={false}
        size="small"
        scroll={{ x: "max-content" }} // ✅ avoid cutoff on small screens
        expandable={{
          expandedRowRender: (record) => (
            <div style={{ overflowX: "auto" }}>
              <FamilyFolioTable
                pan={record.pan}
                onOpenFolioModal={(folioRecord) => {
                  setSelectedFolio(folioRecord);
                  setFolioModalOpen(true);
                }}
                onOpenSchemeModal={(schemeRecord) => {
                  setSelectedScheme(schemeRecord);
                  setSchemeModalOpen(true);
                }}
                onOpenTxnModal={(txnRecord) => {
                  setSelectedTxn(txnRecord);
                  setTxnModalOpen(true);
                }}
              />
            </div>
          ),
          rowExpandable: () => true,
        }}
      />

      {/* ✅ Child Modal */}
      <FamilyChildModal
        open={childModalOpen}
        onClose={() => setChildModalOpen(false)}
        record={selectedChild}
      />

      {/* ✅ Folio Modal */}
      <FolioModal
        open={folioModalOpen}
        onClose={() => setFolioModalOpen(false)}
        record={selectedFolio}
      />

      {/* ✅ Scheme Modal */}
      <SchemeModal
        open={schemeModalOpen}
        onClose={() => setSchemeModalOpen(false)}
        record={selectedScheme}
      />

      {/* ✅ Transaction Modal */}
      <TransactionModal
        open={txnModalOpen}
        onClose={() => setTxnModalOpen(false)}
        record={selectedTxn}
      />
    </>
  );
}
